<div class="dialog" [class.blocked]="isBlocked">
    <!-- Blocking overlay when external changes were detected -->
    <div *ngIf="isBlocked" class="blocking-overlay">
        <div class="blocking-message">
            <icc-icon name="warning" class="warning-icon"></icc-icon>
            <p>{{ 'COMPLAINT|Reklamacja została zmodyfikowana przez innego użytkownika. Dane w tym oknie są nieaktualne i zostały zablokowane do edycji. Zamknij okno i otwórz ponownie, aby zobaczyć aktualne dane.' | translate }}</p>
            <div class="blocking-actions">
                <button iccButton appearance="primary" (click)="close()">
                    {{ 'INTERFACE|Zamknij' | translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="dialog-header">
        <h3>{{ 'COMPLAINT|Edytuj nr korekty i rabat' | translate }}</h3>
        <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>

    </div>
    <div class="dialog-body">

        <div class="complaint-correction-container">

            <div class="complaint-correction-container__correction-number">
                <div class="complaint-correction-container__input">
                    <icc-input
                        type="text"
                        [name]="'correctionNumber'"
                        [value]="correctionNumber"
                        [size]="'medium'"
                        [required]="false"
                        (valueChange)="correctionNumber = $event"
                        [placeholder]="'COMPLAINT|Numer korekty' | translate"
                        [label]="'COMPLAINT|Numer korekty' | translate"
                    ></icc-input>
                </div>
            </div>

            <div class="complaint-correction-container__discount">
                <div class="complaint-correction-container__input">
                    <icc-input
                        type="number"
                        [name]="'discount'"
                        [step]="0.01"
                        [min]="0"
                        [value]="discount"
                        [size]="'medium'"
                        [required]="false"
                        (valueChange)="onDiscountInputChange($event)"
                        [placeholder]="'COMPLAINT|Udzielony rabat' | translate"
                        [label]="'COMPLAINT|Udzielony rabat' | translate"
                        [suffix]="'PLN'"
                    ></icc-input>
                </div>
            </div>

        </div>

    </div>

    <div class="dialog-footer">

        <div class="flex-horizontal w-100">

            <button
                iccButton
                (click)="close()"
                appearance="secondary"
            >
                {{ 'INTERFACE|Zamknij' | translate}}
            </button>
            <button
                iccButton
                (click)="save()"
                appearance="primary"
                [disabled]="!isDiscountValid"
            >
                {{ 'INTERFACE|Zapisz' | translate}}
            </button>

        </div>
    </div>

</div>
<div
    class="curtain"
    (click)="close()"
></div>
